<span class="header-name"
    >{{ params.name | wrapHeaderText }}
    <mat-checkbox
        #matCheckbox
        class="ag-header-mat-checkbox"
        [(checked)]="checked"
        [(indeterminate)]="indeterminate"
        [disabled]="disabled ? true : null"
        (change)="change($event)"
    ></mat-checkbox>
</span>
